"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppBaseAutomationInputUnsupportedError = void 0;
exports.buildAppBaseAutomationBody = buildAppBaseAutomationBody;
/** A binding whose source a button cannot resolve (row, route). */
class AppBaseAutomationInputUnsupportedError extends Error {
    constructor(source) {
        super(`APP_BASE_AUTOMATION_INPUT_SOURCE_UNSUPPORTED:${source}`);
        this.source = source;
        this.name = 'AppBaseAutomationInputUnsupportedError';
    }
}
exports.AppBaseAutomationInputUnsupportedError = AppBaseAutomationInputUnsupportedError;
function buildAppBaseAutomationBody(input) {
    if (input.action.inputBindings.length === 0)
        return { ...input.fields };
    const body = {};
    for (const binding of input.action.inputBindings) {
        switch (binding.source) {
            case 'payload':
                body[binding.targetField] = readPath(input.fields, binding.payloadPath ?? binding.targetField);
                break;
            case 'constant':
                body[binding.targetField] = binding.value ?? null;
                break;
            case 'user':
                body[binding.targetField] =
                    input.principalType === 'anonymous' ? null : input.principalId;
                break;
            default:
                throw new AppBaseAutomationInputUnsupportedError(binding.source);
        }
    }
    return body;
}
function readPath(value, path) {
    let current = value;
    for (const segment of path.split('.')) {
        if (current === null ||
            typeof current !== 'object' ||
            !Object.prototype.hasOwnProperty.call(current, segment)) {
            return null;
        }
        current = current[segment];
    }
    return current ?? null;
}
